import React from "react";

const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const proposalTableShadow = `${publicUrl}/proposal-table-shadow.jpg`;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;

export function ProposalImage({ proposedPropertyData }: any) {
    return (
        <>
            {[...(proposedPropertyData?.proposalDetails?.coverImages || []), ...(proposedPropertyData?.proposalDetails?.innerImages || [])].map(
                (image: string, index: number) => (
                    <table className="table-outer-area page-break"
                        width="100%"
                        key={index}
                        cellPadding="0"
                        cellSpacing="0"
                        style={{
                            // backgroundImage: `url(${require("../../../assets/images/proposal-table-shadow.png")})`,
                            backgroundImage: `url(${proposalTableShadow})`,
                            backgroundPosition: "right",
                            backgroundSize: "cover",
                            marginTop: "15px",
                        }}
                    >
                        <tbody>
                            <tr>
                                <td colSpan={2}>
                                    <table width="100%" cellPadding="0" cellSpacing="0">
                                        <tbody>
                                            <tr>
                                                <td width="85%" style={{ width: "85%" }}>
                                                    <img className="proposal-banner-table"
                                                        src={image}
                                                        style={{ width: "100%", height: "794px", }}
                                                        alt="Proposal Banner"
                                                    />
                                                </td>
                                                <td width="15%"
                                                    valign="top"
                                                    align="right"
                                                    style={{ width: "15%", paddingRight: "15px", paddingLeft: "15px" }}
                                                >
                                                    <img src={logoIcon} alt="cityinfo" width={110} style={{ marginTop: '6px' }} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    align="right"
                                                    colSpan={2}
                                                    style={{ position: "relative" }}
                                                >
                                                    <div
                                                        style={{
                                                            backgroundColor: "#021d77bf",
                                                            borderTopLeftRadius: "16px",
                                                            marginTop: "-140px",
                                                            minWidth: "80%",
                                                            maxWidth: "90%",
                                                            height: "140px",
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <table width="100%" cellPadding="0" style={{ height: "100%" }}>
                                                            <tbody>
                                                                <tr>
                                                                    {(proposedPropertyData?.proposalDetails
                                                                        ?.organizationLogo ||
                                                                        proposedPropertyData?.proposalDetails
                                                                            ?.companyName) && (
                                                                            <>
                                                                                {proposedPropertyData?.proposalDetails
                                                                                    ?.organizationLogo ? (
                                                                                    <td
                                                                                        width="15%"
                                                                                        align="center"
                                                                                        style={{
                                                                                            width: "15%",
                                                                                            borderRight: "solid 1px #fff",
                                                                                            lineHeight: "24px",
                                                                                            fontSize: "17px",
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            // height={80}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                maxWidth: "80px",
                                                                                                height: "auto",
                                                                                                minWidth: "40px",
                                                                                            }}
                                                                                            src={
                                                                                                proposedPropertyData
                                                                                                    ?.proposalDetails
                                                                                                    ?.organizationLogo
                                                                                            }
                                                                                        />
                                                                                    </td>
                                                                                ) : (
                                                                                    <td
                                                                                        align="center"
                                                                                        style={{
                                                                                            maxWidth: "30%",
                                                                                            borderRight: "solid 1px #fff",

                                                                                        }}>
                                                                                        <span style={{
                                                                                            lineHeight: "24px",
                                                                                            fontSize: "22px", color: "#fff", fontWeight: 700
                                                                                        }} >
                                                                                            {
                                                                                                proposedPropertyData
                                                                                                    ?.proposalDetails?.companyName
                                                                                            }
                                                                                        </span>
                                                                                    </td>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    <td style={{
                                                                        whiteSpace: "nowrap", textTransform: "uppercase",
                                                                        fontWeight: 900,
                                                                        fontSize: "35px",
                                                                        color: "#fff",
                                                                        paddingLeft: "16px"
                                                                    }}>
                                                                        {" "}
                                                                        Proposal For Office Space Options
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )
            )}
        </>
    );
}